import request from '../utils/request';
// 获取验证码
export const getVerifyCode = (expires = '') => request(`/common/verify-code?expires=${expires}`);
// 用户登录
export const login = (data) => request({
  url: '/admin/user/login',
  method: 'post',
  data,
});
// 退出登录
export const loginOut = () => request('/admin/user/loginOut');
// 短信验证码
export const sendSmsVcode = (phone) => request(`/common/sms-vcode?phone=${phone}`);
